export default {
  selectedWork(state) {
    return state.videoType === "worksLongFormat" ? state.worksLongFormat.find(work => work.selected) : state.works.find(work => work.selected);
  },
  homeWorks(state) {
    return state.works.filter(work => work.inHome);
  },
  visibleDirectors(state) {
    return state.directors.filter(director => director.show);
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js